import * as React from 'react';
import { twMerge } from 'tailwind-merge';

interface Option { value: string; label: string; }

export function Segmented({ value, onChange, options, className }: { value: string; onChange: (v:string)=>void; options: Option[]; className?: string }) {
  return (
    <div className={twMerge('inline-flex rounded-lg border border-gray-200 dark:border-gray-800 p-0.5 bg-gray-50 dark:bg-gray-950', className)} role="tablist" aria-label="Timeframe">
      {options.map(opt => (
        <button
          key={opt.value}
          role="tab"
          aria-selected={value===opt.value}
          onClick={() => onChange(opt.value)}
          className={twMerge('px-3 py-1.5 text-xs rounded-md outline-none focus:ring-2 focus:ring-offset-2 ring-offset-white dark:ring-offset-gray-950', value===opt.value ? 'bg-white dark:bg-gray-900 shadow text-gray-900 dark:text-gray-100' : 'text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-900')}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
